var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner-outer",class:{'spinner-fixed': _vm.fixed}},[_c('div',{staticClass:"spinner-wrapper"},[_c('b-spinner'),_vm._v(" "),_c('div',{staticClass:"spinner-text"},[_vm._v("\n      "+_vm._s(_vm.text)+"\n    ")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }